// "Areál teď" (#115): who is on site right now, where they stand and for how long.
// Every on-site loading carries `site: { spot, since }` (spot = queue | loading | weighbridge);
// arrival at the gate is its `eta`. Times are compared with the demo clock (HH:MM).

export const SITE_LIMIT_MIN = 45;

const minutesOf = (value) => {
  if (!value) return null;
  if (/^\d{1,2}:\d{2}$/.test(value)) {
    const [h, m] = value.split(':').map(Number);
    return h * 60 + m;
  }
  const d = new Date(value);
  return d.getHours() * 60 + d.getMinutes();
};

const since = (from, clock) => {
  const a = minutesOf(from);
  return a == null ? null : Math.max(0, minutesOf(clock) - a);
};

// One entry per place, in the order a truck passes them. Loading is split by gate.
export const SITE_ZONES = [
  { key: 'queue', match: s => s.spot === 'queue' },
  { key: 'PST', match: (s, l) => s.spot === 'loading' && l.gate === 'PST' },
  { key: 'CLS', match: (s, l) => s.spot === 'loading' && l.gate === 'CLS' },
  { key: 'weighbridge', match: s => s.spot === 'weighbridge' },
];

export function siteNow(loadings, clock) {
  const trucks = loadings
    .filter(l => l.state === 'on-site')
    .map(l => {
      const site = l.site || { spot: 'queue', since: l.eta };
      const onSite = since(l.eta || site.since, clock);
      return { loading: l, site, here: since(site.since, clock), onSite, late: onSite != null && onSite > SITE_LIMIT_MIN };
    })
    .sort((a, b) => (b.onSite ?? 0) - (a.onSite ?? 0));
  const zones = SITE_ZONES.map(z => ({ key: z.key, trucks: trucks.filter(tr => z.match(tr.site, tr.loading)) }));
  return { zones, total: trucks.length, late: trucks.filter(tr => tr.late).length };
}
